import { GoogleBusinessConnectionOptions } from '../../../../../modals/live-orders/LiveOrdersDrawer';

export default {
  titles: {
    disable: 'Czy na pewno chcesz wyłączyć zamówienia na żywo?',
    enable: 'Czy na pewno chcesz włączyć zamówienia na żywo?',
  },
  form: {
    delivery_app_sales_at_go_live: {
      label: 'Miesięczna sprzedaż w aplikacjach dostawczych',
      description:
        'Łączna miesięczna sprzedaż we wszystkich aplikacjach dostawczych (Lieferando, Wolt, Uber Eats …), jako pełna kwota. Wpisz 0, jeśli restauracja nie sprzedaje w żadnej. Po uruchomieniu może ją zmienić tylko administrator.',
      placeholder: 'Wpisz kwotę miesięczną',
    },
    is_google_business_available: {
      label: 'Google Business dostępne',
    },
    is_smart_pricing_configured: {
      label: 'Tańsze ceny niż Lieferando, Wolt, Uber',
    },
    is_flyers_package_sent: {
      label: 'Ulotka promocyjna wysłana',
    },
    is_menu_fully_configured: {
      label: 'Wszystkie pozycje menu dostępne',
    },
    has_offers_on_competitor_platforms: {
      label: 'Czy restauracja ma aktywne oferty na Wolt, Uber, Lieferando (z wyjątkiem bezpłatnej dostawy)?',
    },
    is_instagram_story_shared: {
      label: 'Story na Instagramie udostępnione właścicielowi',
    },
    is_order_system_connected_to_website: {
      label: 'Strona Foodamigos połączona LUB dodano przycisk zamówień online na własnej stronie restauracji',
    },
    google_business_connected_by: {
      label: 'Jak uzyskaliśmy dostęp do profilu Google Business?',
      options: {
        [GoogleBusinessConnectionOptions.SalesManagerOverEmail]: 'Menedżer sprzedaży zaprosił google@foodamigos.io',
        [GoogleBusinessConnectionOptions.SalesManagerOverPhone]:
          'Menedżer sprzedaży wysłał pierwsze żądanie samodzielnie z telefonu właściciela',
        [GoogleBusinessConnectionOptions.OnboardingManagerOverEmail]:
          'Menedżer wdrożenia wnioskował o profil Google Business (SM nie zaprosił i nie wnioskował o dostęp)',
      },
    },
  },
  labels: {
    successful_launch:
      'Aby zapewnić pomyślne uruchomienie, przejrzyj i rozwiąż następujące otwarte kwestie. Weryfikacja \n' +
      'tych informacji pomoże uniknąć potencjalnych problemów po uruchomieniu restauracji.',
    check_errors: 'Sprawdź błędy, aby zapewnić dobre uruchomienie restauracji.',
    checkbox_confirmation: 'Potwierdzam, że przejrzałem błędy i wyrażam zgodę na aktywację tej restauracji.',
  },
  buttons: {
    check_error: 'Sprawdź błąd',
    confirm_and_activate: 'Potwierdź i aktywuj',
    cancel: 'Anuluj',
    yes: 'Tak',
    no: 'Nie',
  },
  errors: {
    name: {
      title: 'Brak arabskich, chińskich itp. znaków w nazwie sklepu',
      description: 'Nazwa sklepu online zawiera znaki inne niż angielskie (łacińskie)',
    },
    logo_url: {
      title: 'Logo',
      description: 'Logo zostało przesłane do sklepu online',
    },
    pictures: {
      title: 'Zdjęcie galerii',
      description: '≥ 1 zdjęcie galerii jest dostępne w sklepie online',
    },
    menu_uploaded: {
      title: 'Menu przesłane',
      description: '≥ 1 menu jest dostępne',
    },
    opening_hours: {
      title: 'Godziny otwarcia',
      description: 'Dodano ≥ 1 godziny otwarcia',
    },
    address: {
      title: 'Adres restauracji',
      description: 'Podano ulicę, miasto, kod pocztowy',
    },
    upsell_items: {
      title: 'Produkty upsell',
      description: 'Wybrano ≥ 3 produkty upsell',
    },
    master_promo_code: {
      title: 'Główny kod promocyjny',
      description: 'Główny kod promocyjny jest dostępny',
    },
    flyers_ordered: {
      title: 'Ulotki zamówione',
      description: 'Zamówiono ≥ 1 pakiet ulotek',
    },
    test_orders: {
      title: 'Zamówienie testowe wysłane',
      description: 'Złożono ≥ 1 zamówienie testowe',
    },
    stripe_billing: {
      title: 'Konto Stripe',
      description: 'Konto Stripe połączone',
    },
    payments_configured: {
      title: 'Płatności skonfigurowane',
      description: 'Partner połączył dostawcę płatności — wymagane przed uruchomieniem',
    },
    adyen_merchant_account: {
      title: 'Konto merchant Adyen',
      description: 'Aktywne konto merchant dla kraju tej restauracji — wymagane dla krajowych stawek kartowych',
    },
    payment_rail_covers_country: {
      title: 'Kanał płatności obsługuje ten kraj',
      description: 'Konta płatnicze partnera mogą obsługiwać kraj tej restauracji',
    },
    identity: {
      title: 'Tożsamość restauracji',
      description: 'Typ restauracji i kuchnia zostały ustawione',
    },
    storefront: {
      title: 'Sklep utworzony i domena połączona',
      description: 'Tylko jeśli restauracja chce korzystać z naszej strony',
    },
    google_business: {
      title: 'Google Business',
      description: 'Google Business połączone',
    },
    billing_payment_method: {
      title: 'Metoda płatności',
      description: 'Dodaj metodę płatności, aby FoodAmigos mógł co miesiąc wystawiać rachunki tej restauracji.',
    },
    billing_license: {
      title: 'Licencja',
      description: 'Ta restauracja potrzebuje planu Partner, zanim będzie mogła wystartować.',
    },
    business_name: {
      title: 'Nazwa firmy / restauracji',
      description: 'Zapisano nazwę widoczną w warunkach korzystania i polityce prywatności',
    },
    payment_method: {
      title: 'Płatności gotówkowe lub online',
      description: 'Płatność gotówką przy odbiorze lub dostawie jest włączona albo płatności online są zweryfikowane',
    },
    stripe_processing_fee: {
      title: 'Prowizja za przetwarzanie',
      description: 'Partner ustawił swoją prowizję Stripe za przetwarzanie płatności lub potwierdził 0% marży',
    },
  },
};
